export function removeEmptyValues(obj: { [key: string]: any }) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== '' && value != null)
  );
}

export function getColorClasses(color: string) {
  switch (color) {
    case 'WHITE':
      return 'bg-white text-black border border-black';
    case 'BLACK':
      return 'bg-black text-white';
    case 'GREY':
      return 'bg-gray-600 text-white';
    case 'BEIGE':
      return 'bg-[#EDE8D0] text-black';
    case 'BLUE':
      return 'bg-blue-600 text-white';
    case 'RED':
      return 'bg-red-600 text-white';
    case 'PINK':
      return 'bg-pink-400 text-black';
    case 'BROWN':
      return 'bg-[#704214] text-white';
    case 'GREEN':
      return 'bg-green-500 text-white';
    case 'CYAN':
      return 'bg-cyan-500 text-black';
    case 'PURPLE':
      return 'bg-purple-700 text-white';
    case 'SILVER':
      return 'bg-[#C4C4C4] text-black';
    case 'ORANGE':
      return 'bg-orange-500 text-white';
    case 'YELLOW':
      return 'bg-orange-400 text-black';
    case 'GOLD':
      return 'bg-[#EFBF04] text-black';
    case 'PEACH':
      return 'bg-[#FFD3AC] text-black';
    case 'MULTICOLOR':
      return 'bg-gradient-to-r from-teal-400 to-yellow-200  text-black';
    case 'OTHER':
      return 'bg-[repeating-linear-gradient(to_right,#898989_0px,#000_3px,#898989_6px)] text-white';
    case 'NOT_APPLICABLE':
      return 'bg-[repeating-linear-gradient(to_right,#f00_0px,#fff_3px,#f00_6px)] text-black';
    default:
      return 'bg-white text-gray-700 border border-gray-700';
  }
}
